import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.5566 4.72655C12.9471 5.11707 12.9471 5.75024 12.5566 6.14076L7.42394 11.2734C7.03342 11.6639 6.40026 11.6639 6.00973 11.2734L3.44341 8.70709C3.05288 8.31656 3.05288 7.6834 3.44341 7.29287C3.83393 6.90235 4.4671 6.90235 4.85762 7.29287L6.71684 9.15209L11.1424 4.72655C11.5329 4.33602 12.1661 4.33602 12.5566 4.72655Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
